import { Loader } from '@beholos/holoscommon';
import type { ProgramInterface } from '../../types/program.interface';

interface StartProgramModalProps {
  program: ProgramInterface;
  loading: boolean;
  signUp: () => void;
  message: string;
}

export default function StartProgramModal({
  program,
  loading,
  signUp,
  message,
}: StartProgramModalProps) {
  return (
    <div className="text-center overflow-hidden bg-white max-w-lg mx-auto">
      <div className="flex items-center justify-between px-4 py-3 border-b">
        <div className="text-left font-bold text-base">Empezar programa</div>
      </div>

      <div className="text-left bg-gray-100 px-6 py-6">
        <div className="text-right font-semibold text-sm mb-1">
          {program.classLengthShort}/{program.days} días
        </div>
        <h3 className="capitalize italic font-bold text-lg mb-2">{program.name}</h3>
        <p className="text-sm text-gray-700">{program.shortDescription}</p>
        {program.instructor && <div className="mt-4 text-sm font-semibold">
          <span className="font-bold">Instructor:</span>{' '}
          <span className="text-holos">{program.instructor}</span>
        </div>}
      </div>

      <button
        className="cursor-pointer bg-holos-dark hover:bg-holos-dark/90 text-white uppercase text-sm font-semibold px-6 py-3 my-4 mx-auto rounded flex items-center w-[300px] h-15 justify-center"
        onClick={!loading ? signUp : undefined}
        disabled={loading}
      >
        {loading ? <Loader /> : 'Empezar programa'}
      </button>

      {message.length > 0 && (
        <p className="text-red-600 text-sm mb-4">{message}</p>
      )}
    </div>
  );
}
